<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/priceControlList' }">价格控制</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails(list.approval_status)">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details details_link">
                        <el-form-item label="开始日期：">
                            <el-input v-model="list.start_date" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="结束日期：">
                            <el-input v-model="list.end_date" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="code：">
                            <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="审批状态：">
                            <el-input
                                v-model="list.approval_status_label"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="产品：">
                            <el-input v-model="list.product_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="时效性：">
                            <el-input v-model="list.timeliness_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="单位底价上限：">
                            <el-input v-model="list.unit_base_price_ub" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="优先：">
                            <el-input v-model="list.priority_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="合作方：">
                            <div class="read_only read_only_link">
                                <span @click="partnerClick(list.partner_rid)">{{ list.partner_name }}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="省份：">
                            <el-input v-model="list.province_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="特征码：">
                            <el-input v-model="list.feature_code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="城市：">
                            <el-input v-model="list.city_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="级别：">
                            <el-input v-model="list.level_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="提交人职位：">
                            <el-input
                                v-model="list.submission_hierarchy_name"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="VATR：">
                            <el-input v-model="list.value_added_tax_rate" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="MEPR：">
                            <el-input
                                v-model="list.marginal_expense_provision_rate"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="产品版本：">
                            <el-input v-model="list.product_version" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label=""> </el-form-item>
                        <el-form-item label="创建人：" prop="created_by">
                            <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by">
                            <div class="read_only">{{ list.updated_by ? list.updated_by : '' }} </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="单位底价信息" name="2">
                    <div class="main_list main_list_color">
                        <div class="toolbar flex" style="margin: 15px 0">
                            <el-button size="small" plain icon="el-icon-plus" @click="addUbple">新增单位底价</el-button>
                        </div>
                        <el-table :data="data" border>
                            <el-table-column prop="unit_base_price_lb" label="单位底价下限" width="120"> </el-table-column>
                            <el-table-column prop="unit_base_price_lb_exclusive_label" label="是否包含本数" width="120"> </el-table-column>
                            <el-table-column prop="decision_rank_label" label="职位等级" width="120"> </el-table-column>
                            <el-table-column prop="standard_price_conversion_factor" label="SR折算系数" width="120">
                                <template slot-scope="scope">
                                    <span
                                        :class="{
                                            excellent: parseFloat(scope.row.standard_price_conversion_factor) >= 0.9,
                                            good:
                                                parseFloat(scope.row.standard_price_conversion_factor) >= 0.82 &&
                                                parseFloat(scope.row.standard_price_conversion_factor) < 0.9,
                                            common:
                                                parseFloat(scope.row.standard_price_conversion_factor) >= 0.54 &&
                                                parseFloat(scope.row.standard_price_conversion_factor) < 0.82,
                                            remind:
                                                parseFloat(scope.row.standard_price_conversion_factor) >= 0.24 &&
                                                parseFloat(scope.row.standard_price_conversion_factor) < 0.54,
                                            warn: parseFloat(scope.row.standard_price_conversion_factor) < 0.24,
                                            blak: parseFloat(scope.row.standard_price_conversion_factor) <= 0
                                        }"
                                    >
                                        {{ scope.row.standard_price_conversion_factor }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="180">
                                <template slot-scope="scope" style="height: 100%">
                                    <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                        <i class="el-icon-s-claim" @click="editScope(scope.row)"></i>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                        <i class="el-icon-delete-solid" @click="deleteScope(scope.row)"></i>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="dialogVisible" width="68%">
                        <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details">
                            <el-form-item label="单位底价下限：" prop="unit_base_price_lb">
                                <el-input
                                    v-model="ruleForm.unit_base_price_lb"
                                    size="mini"
                                    placeholder="请输入单位底价下限"
                                    type="number"
                                    :min="0"
                                    clearable
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="是否包含本数：" prop="unit_base_price_lb_exclusive">
                                <div style="width: 280px">
                                    <el-switch v-model="unit_lb_checked" active-color="#13ce66" inactive-color="#cccccc" @change="priceLb">
                                    </el-switch>
                                </div>
                            </el-form-item>
                            <el-form-item label="职位等级：" prop="decision_rank">
                                <el-select
                                    v-model="ruleForm.decision_rank"
                                    placeholder="请选择职位等级"
                                    clearable
                                    style="width: 100%"
                                    filterable
                                    size="small"
                                >
                                    <el-option v-for="item in rankOptions" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="okData('ruleDetailsForm')">确 定</el-button>
                        </span>
                    </el-dialog>
                </el-collapse-item>
                <el-collapse-item disabled title="流程行" name="3">
                    <!-- <div class="main_list">
                        <div class="main_header_btns">
                            <el-popover placement="left" trigger="click" class="top_btn" width="200px">
                                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
                                    >全选</el-checkbox
                                >
                                <el-checkbox-group
                                    v-model="colOptions"
                                    style="display: flex; flex-direction: column"
                                    @change="handleCheckedCitiesChange"
                                >
                                    <el-checkbox v-for="item in colSelect" :label="item" :key="item"></el-checkbox>
                                </el-checkbox-group>
                                <el-button slot="reference" size="mini" icon="el-icon-setting">设置</el-button>
                            </el-popover>
                        </div>
                        <el-table :data="dataList" border style="width: 100%" ref="tableDataRef" element-loading-text="数据拼命加载中">
                            <el-table-column
                                v-if="colData[0].istrue"
                                prop="rel_name"
                                label="对象名称"
                                align="left"
                                show-overflow-tooltip
                                width="120px"
                            >
                            </el-table-column>
                            <el-table-column v-if="colData[1].istrue" prop="name" label="流程行名称" align="left" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                v-if="colData[2].istrue"
                                prop="status_label"
                                label="状态"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column v-if="colData[3].istrue" prop="type_label" label=" 类型" align="left" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                v-if="colData[4].istrue"
                                prop="operator_hierarchy_names"
                                label="可审批职位"
                                align="left"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colData[5].istrue"
                                prop="operator_name"
                                label="审批人"
                                align="left"
                                show-overflow-tooltip
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colData[6].istrue"
                                prop="operator_hierarchy_name"
                                label="审批人职位"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colData[7].istrue"
                                prop="operation_label"
                                label="执行意见"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colData[8].istrue"
                                prop="comment"
                                label="意见说明"
                                align="left"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                v-if="colData[9].istrue"
                                prop="sequence"
                                label="序号"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            ></el-table-column>
                            <el-table-column
                                v-if="colData[10].istrue"
                                prop="next_sequence"
                                label="下一步序号"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            >
                            </el-table-column>
                            <el-table-column
                                v-if="colData[11].istrue"
                                prop="operator_number"
                                label="执行人数"
                                align="left"
                                show-overflow-tooltip
                                width="180px"
                            >
                            </el-table-column>
                            <el-table-column label="操作" width="180">
                                <template slot-scope="scope" style="height: 100%">
                                    <div v-show="scope.row.wait_me_approve == 1">
                                        <button
                                            type="button"
                                            class="el-button el-button--text el-button--small"
                                            @click="okPassLine(3, scope)"
                                        >
                                            <span>通过</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="el-button el-button--text el-button--small"
                                            @click="okPassLine(4, scope)"
                                        >
                                            <span>拒绝</span>
                                        </button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-dialog
                            v-dialogDrag
                            :close-on-click-modal="false"
                            title="审核意见"
                            :visible.sync="dialogVisibleLine"
                            width="30%"
                        >
                            <el-input type="textarea" :rows="2" placeholder="请输入审核意见" v-model="comment"> </el-input>
                            <span slot="footer" class="dialog-footer">
                                <el-button
                                    @click="
                                        dialogVisibleLine = false;
                                        comment = '';
                                    "
                                    >取 消</el-button
                                >
                                <el-button type="primary" @click="subData">确 定</el-button>
                            </span>
                        </el-dialog>
                    </div> -->
                </el-collapse-item>
                <el-collapse-item disabled title="图表信息" name="4">
                    <div class="echartsFlex">
                        <div class="echart_div">
                            <div class="echarts_input">
                                <span class="echarts_span">单位底价下限:</span>
                                <el-select clearable filterable v-model="drawValue1" size="mini" style="width: 100px" @change="valueChange">
                                    <el-option v-for="item in options1" :key="item" :label="item" :value="item"> </el-option>
                                </el-select>
                                <el-input v-model="unit_invoice_price_series_start_scale" size="mini" readonly="">
                                    <template slot="prepend">开始刻度</template>
                                </el-input>
                                <el-input v-model="unit_invoice_price_series_scale_interval" size="mini" readonly="">
                                    <template slot="prepend">刻度间隔</template></el-input
                                >
                                <el-input clearable v-model="unit_invoice_price_series_scales" size="mini">
                                    <template slot="prepend">刻度数</template></el-input
                                >
                                <el-button
                                    @click="
                                        draw1(
                                            unit_invoice_price_series_start_scale,
                                            unit_invoice_price_series_scale_interval,
                                            unit_invoice_price_series_scales,
                                            drawValue1,
                                            list['marginal_expense_provision_rate']
                                        )
                                    "
                                    >查看</el-button
                                >
                                <el-tooltip
                                    class="tooltips"
                                    effect="dark"
                                    content="开始刻度、刻度间隔自动根据单位底价下限联动变化"
                                    placement="top-start"
                                >
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </div>
                            <div id="main_1" v-show="echartShow"></div>
                        </div>
                        <div class="echart_div">
                            <div class="echarts_input">
                                <el-input v-model="unit_base_price_series_start_scale" size="mini" readonly="">
                                    <template slot="prepend">开始刻度</template></el-input
                                >
                                <el-input v-model="unit_base_price_series_scale_interval" size="mini" readonly="">
                                    <template slot="prepend">刻度间隔</template></el-input
                                >
                                <el-input v-model="unit_base_price_series_scales" size="mini" clearable>
                                    <template slot="prepend">刻度数</template></el-input
                                >
                                <el-button
                                    @click="
                                        draw2(
                                            unit_base_price_series_start_scale,
                                            unit_base_price_series_scale_interval,
                                            unit_base_price_series_scales,
                                            list['unit_sales_standard_cost'],
                                            list['standard_sales_gross_profit_rate']
                                        )
                                    "
                                    >查看</el-button
                                >
                            </div>
                            <div id="main_2" v-show="echartShow"></div>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    inject: ['reload'],
    name: 'priceControlDetail',
    data() {
        return {
            num: '0.56',
            list: {},
            activeNames: ['1', '2', '3', '4'],
            rid: '',
            headerTitle: '价格控制详情',
            rankOptions: [],
            echartShow: true,
            labelPosition: 'right',
            unit_invoice_price_series_start_scale: 10,
            unit_invoice_price_series_scale_interval: 10,
            unit_invoice_price_series_scales: 11,
            unit_base_price_series_start_scale: 10,
            unit_base_price_series_scale_interval: 10,
            unit_base_price_series_scales: 11,
            data: [],
            title: '',
            dialogVisible: false,
            ruleForm: {
                unit_base_price_lb: '',
                decision_rank: ''
            },
            rules: {
                unit_base_price_lb: [{ required: true, message: '请输入单位底价下限', trigger: 'blur' }],
                decision_rank: [{ required: true, message: '请选择职位等级', trigger: 'blur' }]
            },
            unit_lb_checked: true,
            typeLb: '1',
            include: '1',
            type: '',
            lineRid: '',
            options1: [],
            options2: [],
            drawValue1: '',
            comment: '',
            dialogVisibleLine: false,
            dataList: [],
            dataType: '',
            //控制列
            colData: [
                { title: '对象名称', istrue: true },
                { title: '流程行名称', istrue: true },
                { title: '状态', istrue: true },
                { title: '类型', istrue: true },
                { title: '可审批职位', istrue: true },
                { title: '审批人', istrue: true },
                { title: '审批人职位', istrue: true },
                { title: '执行意见', istrue: true },
                { title: '意见说明', istrue: true },
                { title: '序号', istrue: true },
                { title: '下一步序号', istrue: true },
                { title: '执行人数', istrue: true }
            ],
            colOptions: [
                '对象名称',
                '流程行名称',
                '状态',
                '类型',
                '可审批职位',
                '审批人',
                '审批人职位',
                '执行意见',
                '意见说明',
                '序号',
                '下一步序号',
                '执行人数'
            ], //默认全选
            // 筛选列
            colSelect: [
                '对象名称',
                '流程行名称',
                '状态',
                '类型',
                '可审批职位',
                '审批人',
                '审批人职位',
                '执行意见',
                '意见说明',
                '序号',
                '下一步序号',
                '执行人数'
            ],
            checkAll: true,
            isIndeterminate: false,
            selected: [],
            rids: []
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.reload();
        },
        //控制列显示
        colOptions(valArr) {
            var arr = this.colSelect.filter((i) => valArr.indexOf(i) < 0); // 未选中
            this.colData.filter((i) => {
                if (arr.indexOf(i.title) != -1) {
                    i.istrue = false;
                    this.$nextTick(() => {
                        this.$refs.tableDataRef.doLayout();
                    });
                } else {
                    i.istrue = true;
                    this.$nextTick(() => {
                        this.$refs.tableDataRef.doLayout();
                    });
                }
            });
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.getDetails(); //获取详情
        this.getLineList(); //获取流程行列表
        this.getRank();
    },
    methods: {
        //全选设置列表 列显示
        handleCheckAllChange(val) {
            this.isIndeterminate = false;
            if (val) {
                this.colOptions = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
                this.colSelect = [
                    '对象名称',
                    '流程行名称',
                    '状态',
                    '类型',
                    '可审批职位',
                    '审批人',
                    '审批人职位',
                    '执行意见',
                    '意见说明',
                    '序号',
                    '下一步序号',
                    '执行人数'
                ];
            } else {
                this.colOptions = [];
            }
        },
        //单选设置列表 列显示
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.colData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.colData.length;
        },
        //type == 3审批通过 type ==4 拒绝
        okPassLine(type, scope) {
            this.dataType = type;
            this.dialogVisibleLine = true;
            this.rids.push(scope.row.rel_rid);
        },
        //提交通过拒绝弹窗
        subData() {
            if (this.dataType == 3) {
                //此处为通过
                let postData = {
                    rids: this.rids,
                    approval_status: 3,
                    comment: this.comment
                };
                this.$api
                    .priceControlBatchAudit(postData)
                    .then((res) => {
                        this.dialogVisibleLine = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '审批通过!',
                                type: 'success'
                            });
                            this.getDetails(); //获取详情
                            this.getLineList(); //获取流程行列表
                        }
                    })
                    .catch((error) => {
                        this.dialogVisibleLine = false;
                        
                    });
            } else if (this.dataType == 4) {
                //此处为拒绝
                let postData = {
                    rids: this.rids,
                    approval_status: 4,
                    comment: this.comment
                };
                this.$api
                    .priceControlBatchAudit(postData)
                    .then((res) => {
                        this.dialogVisibleLine = false;
                        if (res.code == 0) {
                            this.$message({
                                message: '已拒绝!',
                                type: 'waring'
                            });
                            this.getDetails(); //获取详情
                            this.getLineList(); //获取流程行列表
                        }
                    })
                    .catch((error) => {
                        this.dialogVisibleLine = false;
                        
                    });
            }
        },
        // 多选选择框选择
        selectionChange(val) {
            this.selected = val;
        },
        //获取流程行列表
        getLineList() {
            let params = {
                for_detail: 1,
                rel_type: 'price_control',
                rel_rid: this.rid
            };
            this.$api
                .procedureLineDetailsList(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.dataList = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //获取职位等级
        getRank() {
            let params = {};
            this.$api
                .decisionRank(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.rankOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.rankOptions.push({
                                value: value.value,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {
                    
                });
        },
        //删除
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .priceControlDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/priceControlList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        valueChange(val) {
            this.unit_invoice_price_series_start_scale = val;
            this.unit_invoice_price_series_scale_interval = val * 0.2;
            this.unit_base_price_series_start_scale = val;
            this.unit_base_price_series_scale_interval = val * 0.03;
        },
        //数据确认
        okData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type == 1) {
                        this.submitAddData(); // 新增
                    } else if (this.type == 2) {
                        this.submitEditData(); //修改
                    }
                } else {
                    return false;
                }
            });
        },
        //新增
        submitAddData() {
            let params = {
                unit_base_price_lb: this.ruleForm.unit_base_price_lb ? this.ruleForm.unit_base_price_lb : '',
                unit_base_price_lb_exclusive: this.typeLb,
                decision_rank: this.ruleForm.decision_rank,
                price_control_rid: this.rid
            };
            this.$api
                .priceControlHierarchyInsert(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.dialogVisible = false;
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.getDetails(); //获取详情
                    }
                })
                .catch((error) => {
                    
                });
        },
        //编辑
        submitEditData() {
            let params = {
                unit_base_price_lb: this.ruleForm.unit_base_price_lb ? this.ruleForm.unit_base_price_lb : '',
                unit_base_price_lb_exclusive: this.typeLb,
                decision_rank: this.ruleForm.decision_rank,
                rid: this.lineRid
            };
            this.$api
                .priceControlHierarchyUpdate(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.dialogVisible = false;
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.getDetails(); //获取详情
                        this.getLineList(); //获取流程行列表
                    }
                })
                .catch((error) => {
                    
                });
        },
        //新增按钮
        addUbple() {
            this.dialogVisible = true;
            this.title = '新增单位底价';
            this.type = 1;
            this.ruleForm = {
                unit_base_price_lb: '',
                decision_rank: ''
            };
            this.unit_lb_checked = true;
        },
        //是否包含本数
        priceLb(value) {
            if (value) {
                this.typeLb = '1';
            } else {
                this.typeLb = '2';
            }
        },
        //编辑窗口
        editScope(row) {
            this.ruleForm = {
                unit_base_price_lb: '',
                decision_rank: ''
            };
            this.unit_lb_checked = false;
            this.title = '修改单位底价';
            this.dialogVisible = true;
            this.type = 2;
            this.lineRid = row.rid;
            this.ruleForm.unit_base_price_lb = row.unit_base_price_lb;
            this.ruleForm.decision_rank = row.decision_rank;
            if (row.unit_base_price_lb_exclusive == 1) {
                this.unit_lb_checked = true;
            } else {
                this.unit_lb_checked = false;
            }
            this.typeLb = row.unit_base_price_lb_exclusive;
        },
        deleteScope(row) {
            let id = row.id;
            this.$msgbox
                .confirm('确认删除当前行吗?', '提示', {
                    type: 'warning'
                })
                .then(() => {
                    let params = {
                        id: id
                    };
                    this.$api
                        .priceControlHierarchyDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '删除成功！',
                                    type: 'success'
                                });
                                this.getDetails();
                            }
                        })
                        .catch((error) => {
                            
                        });
                })
                .catch(() => {
                });
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'priceControlEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //合作方详情跳转
        partnerClick(rid) {
            this.$router.push({
                path: 'partnerDetails',
                query: {
                    id: rid
                }
            });
        },
        //前往编辑页面
        editDetails(status) {
            if (status == 3) {
                this.$message({
                    message: '审批状态为已批准的不能修改！',
                    type: 'warning'
                });
            } else {
                this.$router.push({
                    path: '/priceControlEdit',
                    query: {
                        type: 1,
                        id: this.rid
                    }
                });
            }
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'priceControlEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/priceControlList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .priceControlDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        this.data = res.data.hierarchies;
                        document.title = this.headerTitle + ':' + res.data.code;
                        this.options1 = res.data.unit_base_price_lbs;
                        this.drawValue1 = this.list['hierarchies'][0]['unit_base_price_lb'];
                        this.unit_invoice_price_series_start_scale = this.drawValue1;
                        this.unit_invoice_price_series_scale_interval = this.drawValue1 * 0.2;
                        this.unit_invoice_price_series_scale_interval = this.unit_invoice_price_series_scale_interval.toFixed(2);
                        this.unit_base_price_series_start_scale = this.drawValue1;
                        this.unit_base_price_series_scale_interval = this.drawValue1 * 0.03;
                        this.draw1(
                            this.unit_invoice_price_series_start_scale,
                            this.unit_invoice_price_series_scale_interval,
                            this.unit_invoice_price_series_scales,
                            this.drawValue1,
                            this.list['marginal_expense_provision_rate']
                        );
                        this.draw2(
                            this.unit_base_price_series_start_scale,
                            this.unit_base_price_series_scale_interval,
                            this.unit_base_price_series_scales,
                            this.list['unit_sales_standard_cost'],
                            this.list['standard_sales_gross_profit_rate']
                        );
                    }
                })
                .catch((error) => {
                    
                });
        },
        //计算最大值
        calMax(arr) {
            let max = 0;
            arr.forEach((el) => {
                el.forEach((el1) => {
                    if (!(el1 === undefined || el1 === '')) {
                        if (max < el1) {
                            max = el1;
                        }
                    }
                });
            });
            let maxint = Math.ceil(max / 10); //不让最高的值超过最上面的刻度
            let maxval = maxint * 10; //让显示的刻度是整数
            return maxval;
        },
        //计算最小值
        calMin(arr) {
            let min = 0;
            arr.forEach((el) => {
                el.forEach((el1) => {
                    if (!(el1 === undefined || el1 === '')) {
                        if (min > el1) {
                            min = el1;
                        }
                    }
                });
            });
            let minint = Math.floor(min / 10);
            let minval = minint * 10; //让显示的刻度是整数
            return minval;
        },
        //发票单价 echarts方法
        draw1(
            unit_invoice_price_series_start_scale,
            unit_invoice_price_series_scale_interval,
            unit_invoice_price_series_scales,
            unit_base_price_lb,
            marginal_expense_provision_rate
        ) {
            var chartDom = document.getElementById('main_1');
            var myChart = this.$echarts.init(chartDom);

            unit_invoice_price_series_start_scale = parseFloat(unit_invoice_price_series_start_scale);
            unit_invoice_price_series_scale_interval = parseFloat(unit_invoice_price_series_scale_interval);
            unit_invoice_price_series_scales = parseInt(unit_invoice_price_series_scales);
            unit_base_price_lb = parseFloat(unit_base_price_lb);
            marginal_expense_provision_rate = parseFloat(marginal_expense_provision_rate);

            var outData = {
                unit_invoice_price: [],
                unit_base_price_ub: [],
                limit_rate_cap: []
            };

            for (let i = 1; i <= unit_invoice_price_series_scales; i++) {
                var unit_invoice_price = (
                    unit_invoice_price_series_start_scale +
                    unit_invoice_price_series_scale_interval * (i - 1)
                ).toFixed(2);
                var unit_base_price_ub = 0;
                var limit_rate_cap = 0;
                if (unit_invoice_price != 0) {
                    limit_rate_cap = (unit_base_price_ub / unit_invoice_price).toFixed(4);
                }
                outData['unit_invoice_price'].push(unit_invoice_price);
                outData['unit_base_price_ub'].push(unit_base_price_ub);
                outData['limit_rate_cap'].push(limit_rate_cap);
            }
            var newData = outData.limit_rate_cap;
            var len = newData.length;
            for (var i = 0; i < len; ++i) {
                newData[i] = (newData[i] * 100).toFixed(2);
            }
            var Min2 = this.calMin([outData.unit_base_price_ub]),
                Min1 = this.calMin([outData.limit_rate_cap]);
            var length1 = outData.limit_rate_cap.length - 1;
            var Max1 = Math.ceil(outData.limit_rate_cap[length1]);
            var length2 = outData.unit_base_price_ub.length - 1;
            var Max2 = Math.ceil(outData.unit_base_price_ub[length2]);
            var option;
            option = {
                title: {
                    text: '发票单价',
                    x: 'center', //水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
                    y: 'bottom' //垂直安放位置，默认为top，可选为：'top' | 'bottom' | 'center' | {number}（y坐标，单位px）
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    },
                    formatter: function (params) {
                        let str = '';
                        params.forEach((item, idx) => {
                            str += `${item.marker}${item.seriesName}: ${item.data}`;
                            switch (idx) {
                                case 0:
                                    str += '%';
                                    break;
                                case 1:
                                    str += '元';
                                    break;
                            }
                            str += idx === params.length - 1 ? '' : '<br/>';
                        });
                        return str;
                    }
                },
                legend: {
                    data: ['限额率', '单位限额']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: outData.unit_invoice_price,
                        axisLabel: {
                            formatter: '{value} '
                        },
                        axisPointer: {
                            type: 'shadow'
                        },
                        splitNumber: 11
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '限额率',
                        axisLabel: {
                            formatter: '{value}% ' //以百分比显示,
                        },
                        min: Min1,
                        max: Max1,
                        splitNumber: 5,
                        interval: (Max1 - Min1) / 5
                    },
                    {
                        type: 'value',
                        name: '单位限额',
                        axisLabel: {
                            formatter: '{value}'
                        },
                        axisTick: {
                            show: false //不显示坐标轴轴线
                        },
                        min: Min2,
                        max: Max2,
                        splitNumber: 5,
                        interval: (Max2 - Min2) / 5
                    }
                ],
                series: [
                    {
                        name: '限额率',
                        type: 'line',
                        yAxisIndex: 0,
                        data: outData.limit_rate_cap,
                        markLine: {
                            symbol: 'none', //去掉警戒线最后面的箭头
                            //     /*label:{
                            //        position:"end"   ,       //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
                            //    },*/
                            data: [
                                {
                                    silent: false, //鼠标悬停事件  true没有，false有
                                    lineStyle: {
                                        //警戒线的样式  ，虚实  颜色
                                        type: 'solid',
                                        color: '#03c524'
                                    },
                                    label: {
                                        position: 'start',
                                        formatter: '良好40%'
                                    },
                                    yAxis: 40 // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                                }
                            ]
                        }
                    },
                    {
                        name: '单位限额',
                        type: 'line',
                        yAxisIndex: 1,
                        data: outData.unit_base_price_ub
                    }
                ]
            };
            option && myChart.setOption(option);
        },
        //单位底价 echarts方法
        draw2(
            unit_base_price_series_start_scale,
            unit_base_price_series_scale_interval,
            unit_base_price_series_scales,
            unit_sales_standard_cost,
            standard_sales_gross_profit_rate
        ) {
            var chartDom = document.getElementById('main_2');
            var myChart = this.$echarts.init(chartDom);

            unit_base_price_series_start_scale = parseFloat(unit_base_price_series_start_scale);
            unit_base_price_series_scale_interval = parseFloat(unit_base_price_series_scale_interval);
            unit_base_price_series_scales = parseInt(unit_base_price_series_scales);
            unit_sales_standard_cost = parseFloat(unit_sales_standard_cost);
            standard_sales_gross_profit_rate = parseFloat(standard_sales_gross_profit_rate);

            let outData1 = {
                unit_base_price: [],
                unit_base_sr: [],
                standard_price_conversion_factor: []
            };

            for (let i = 1; i <= unit_base_price_series_scales; i++) {
                var unit_base_price = (unit_base_price_series_start_scale + unit_base_price_series_scale_interval * (i - 1)).toFixed(2);
                var unit_base_sr = 0;
                var standard_price_conversion_factor = ((unit_base_sr / unit_base_price) * 100).toFixed(2);

                outData1['unit_base_price'].push(unit_base_price);
                outData1['unit_base_sr'].push(unit_base_sr);
                outData1['standard_price_conversion_factor'].push(standard_price_conversion_factor);
            }
            var Min1 = this.calMin([outData1.unit_base_sr]),
                Min2 = this.calMin([outData1.standard_price_conversion_factor]);
            var length1 = outData1.unit_base_sr.length - 1;
            var Max1 = Math.ceil(outData1.unit_base_sr[length1]);
            var length2 = outData1.standard_price_conversion_factor.length - 1;
            var Max2 = Math.ceil(outData1.standard_price_conversion_factor[length2]);
            var option;
            option = {
                title: {
                    text: '单位底价',
                    x: 'center', //水平安放位置，默认为'left'，可选为：'center' | 'left' | 'right' | {number}（x坐标，单位px）
                    y: 'bottom' //垂直安放位置，默认为top，可选为：'top' | 'bottom' | 'center' | {number}（y坐标，单位px）
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    },
                    formatter: function (params) {
                        let str = '';
                        params.forEach((item, idx) => {
                            str += `${item.marker}${item.seriesName}: ${item.data}`;
                            switch (idx) {
                                case 0:
                                    str += '元';
                                    break;
                                case 1:
                                    str += '%';
                                    break;
                            }
                            str += idx === params.length - 1 ? '' : '<br/>';
                        });
                        return str;
                    }
                },
                legend: {
                    data: ['单位SR', 'SR折算系数']
                },
                xAxis: [
                    {
                        type: 'category',
                        data: outData1.unit_base_price,
                        axisLabel: {
                            formatter: '{value} '
                        },
                        axisPointer: {
                            type: 'shadow'
                        },
                        splitNumber: 11
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '单位SR',
                        axisLabel: {
                            formatter: '{value} ' //以百分比显示,
                        },
                        min: Min1,
                        max: Max1,
                        splitNumber: 5,
                        interval: (Max1 - Min1) / 5
                    },
                    {
                        type: 'value',
                        name: 'SR折算系数',
                        axisLabel: {
                            formatter: '{value}%'
                        },
                        axisTick: {
                            show: false //不显示坐标轴轴线
                        },
                        min: Min2,
                        max: Max2,
                        splitNumber: 5,
                        interval: (Max2 - Min2) / 5
                    }
                ],
                series: [
                    {
                        name: '单位SR',
                        type: 'line',
                        yAxisIndex: 0,
                        data: outData1.unit_base_sr
                    },
                    {
                        name: 'SR折算系数',
                        type: 'line',
                        yAxisIndex: 1,
                        data: outData1.standard_price_conversion_factor
                    }
                ]
            };
            option && myChart.setOption(option);
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
.echartsFlex {
    width: 100%;
    margin: 10px 0 0 0;
    display: flex;
    justify-content: space-around;
    #main_1 {
        margin-top: 20px;
        width: 550px;
        height: 400px;
    }
    #main_2 {
        margin-top: 20px;
        width: 550px;
        height: 400px;
    }
    .echart_div {
        width: 30%;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
    }
    .echarts_input {
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: relative;
        .echarts_span {
            margin: 0 5px 0 0;
            display: inline-block;
            width: 85px;
        }
        .el-input {
            width: 90px;
            margin: 0 2px;
            /deep/.el-input-group__prepend {
                padding: 5px;
            }
            /deep/.el-input__inner {
                padding: 0;
                padding-left: 2px;
                width: 60px;
            }
        }
    }
}
</style>